const SearchTogglerView = Backbone.View.extend({
  /**
   * Init SearchToggler view
   * @param context - to access SearchView context
   */
  initialize: function ({ context }) {
    this.context = context;
    this.isHome = $('body').hasClass('home');
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.initListeners();
    this.render();
  },

  /**
   * Render the view
   */
  render: function () {
    this.updateDomains();
    this.updateDates();
    this.updateChildrenOnMobile();
    this.updateParticipants();
  },

  initListeners: function () {
    // on model change => re-render view
    this.listenTo(this.model, 'change', this.render);

    // on manual trigger => re-render view
    this.stopListening(dispatcher, 'search:toggler:render');
    this.listenTo(dispatcher, 'search:toggler:render', this.render);

    this.stopListening(dispatcher, 'search:toggler:updateDates');
    this.listenTo(dispatcher, 'search:toggler:updateDates', this.updateDates);

    this.stopListening(dispatcher, 'search:toggler:updateParticipants');
    this.listenTo(dispatcher, 'search:toggler:updateParticipants', this.updateParticipants);
  },

  updateDomains: function () {
    // Get label from desktop field version
    $('#searchToggler-domaines').html($('.js-domainSelector .js_data').html());
  },

  /**
   * Update dates in toggler
   * @param {string} dateStart - format: 'yyyy-MM-dd'
   * @param {string} dateEnd - format: 'yyyy-MM-dd'
   */
  updateDates: function (dateStart, dateEnd) {
    if (this.model.get('isFlexPeriod')) {
      dispatcher.trigger('facette:flexPeriod:updateSearchToggler');
    } else {
      const htmldate_separator = '<i class="icon icon-transfer1"></i>';
      let arrivalDate = dateStart || null;
      let departureDate = dateEnd || null;
      let htmlDates = this.wordings.searchform_toggler_date_label;

      if (!arrivalDate && this.model.has('arrivalDate') && this.model.get('arrivalDate') !== '') {
        arrivalDate = this.model.get('arrivalDate');
      }
      if (!departureDate && this.model.has('departureDate') && this.model.get('departureDate') !== '') {
        departureDate = this.model.get('departureDate');
      }

      // Update dates label
      if (arrivalDate && arrivalDate.length) {
        // Convert arrivalDate to "DD/MM/YY" format
        if (arrivalDate.indexOf('-') !== -1) {
          arrivalDate = genericDate.toDisplay(arrivalDate);
        }

        if (departureDate && departureDate.length) {
          // Convert departureDate to "DD/MM/YY" format
          if (departureDate.indexOf('-') !== -1) {
            departureDate = genericDate.toDisplay(departureDate);
          }
          htmlDates = arrivalDate + ' ' + htmldate_separator + ' ' + departureDate;
        } else {
          // if only arrivalDate, prefix with wording
          htmlDates = this.wordings.searchform_toggler_date_from + ' ' + arrivalDate;
        }
      }

      // Fill label with wording or dates
      $('#searchToggler-dates').html(htmlDates);
    }
  },

  updateChildrenOnMobile: function () {
    // Force updates childs count on mobile devices WPI-36179 & WPI-36642
    if (DEVICE.isMobile) {
      $(document).on('click', '#searchEngine-children .js-quantitySelect, #searchEngine-children_02 .js-quantitySelect', function (_event) {
        dispatcher.trigger('search:toggler:updateParticipants');
      });
    }
  },

  updateParticipants: function () {
    // Get datas from model
    const nbParticipants = this.model.get('totalParticipants');
    const nbCottages = this.model.get('accommodationNb');
    const nbPets = this.model.get('multiparticipants')[0].pets + this.model.get('multiparticipants')[1].pets;

    $('#searchToggler-nbParticipants').html(nbParticipants);
    $('#searchToggler-nbCottage').html(nbCottages);
    $('#searchToggler-nbPets').html(nbPets);
    // hide container if no pets
    $('.searchToggler-pets').toggleClass('u-Hidden--forced', parseInt(nbPets) === 0);
  }
});

export default SearchTogglerView;